import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { browserRoutes } from "../../../../config/browserRoutes";

const PublicRoute = ({ children }) => {
  const authData = useSelector((state) => state?.auth);
  console.log("PublicRoute - authData:", authData);

  if (!authData?.isLogin) {
    console.log("User not logged in, showing login page");
    return children;
  } else {
    console.log("User logged in, redirecting to analytics");
    return <Navigate to={browserRoutes?.analytics} />;
  }
};

export default PublicRoute;
